export const PageName = {
  Orders: 'Order',
  OrderRequest: 'OrderRequest',
  Cylinders: 'Cylinder'
};
export const getClientIdsByScreenAccess = (data, pageName) => data
  .filter((item) => {
    if (!item.OverrideRoleSetting) return false;
    const overrideSettings = JSON.parse(item.OverrideRoleSetting);
    const pageNameKey = PageName[pageName] ?? pageName;
    return overrideSettings.some((setting) =>
      setting.Text.toLowerCase() === pageNameKey.toLowerCase());
  })
  .map((record) => JSON.parse(record.Group1).ID);

export const getClientIdsScreenAccessByState = (state, pageName) => {
  const userToRoles = state?.auth?.loginUser?.userToRoles || [];
  return getClientIdsByScreenAccess(userToRoles, pageName);
};
export const getClientIdsScreenAccessByData = (data, pageName) => getClientIdsByScreenAccess(data, pageName);
